/**
 * ExplorationLimitBar - Top bar showing exploration progress and limit
 *
 * Shows:
 * - Current explored / limit count
 * - Warning states when near limit
 * - Clickable to show detailed tooltip
 */

import React, { useState } from 'react';
import { BALANCE } from '../../../data/balance';
import ExplorationLimitTooltip from './ExplorationLimitTooltip';

function ExplorationLimitBar({
  totalDiscovered,
  explorationLimit,
  explorationBonusInfo,
}) {
  const [showTooltip, setShowTooltip] = useState(false);

  const warningConfig = BALANCE.antiFrustration?.explorationWarning;
  const threshold = warningConfig?.enabled ? warningConfig.warningThreshold : 1;
  const isNearLimit = totalDiscovered >= explorationLimit * threshold && totalDiscovered < explorationLimit;
  const isAtLimit = totalDiscovered >= explorationLimit;

  return (
    <>
      <div
        className={`wm-explore-limit ${showTooltip ? 'active' : ''} ${isNearLimit ? 'warning' : ''} ${isAtLimit ? 'at-limit' : ''}`}
        onClick={() => setShowTooltip(p => !p)}
        title={isNearLimit ? warningConfig?.message : isAtLimit ? 'Exploration limit reached!' : ''}
      >
        <span className="wm-explore-icon">{isAtLimit ? '⚠️' : isNearLimit ? '⚡' : '🗺️'}</span>
        <span
          className="wm-explore-text"
          style={isNearLimit ? { color: '#f59e0b' } : isAtLimit ? { color: '#ef4444' } : {}}
        >
          {totalDiscovered}/{explorationLimit}
        </span>
        <span className="wm-explore-hint">ⓘ</span>
      </div>
      {showTooltip && (
        <ExplorationLimitTooltip
          explorationBonusInfo={explorationBonusInfo}
          onClose={() => setShowTooltip(false)}
        />
      )}
    </>
  );
}

export default ExplorationLimitBar;
